function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 5");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.69155206,5.88015717 C5.57662083,5.59037328 5.21807466,5.29076621 5.21807466,4.82416503 C5.21807466,4.28880157 5.71414538,3.91552063 6.54420432,3.91552063 C7.41846758,3.91552063 7.74263261,4.33300589 7.77210216,4.94695481 L8.85756385,4.94695481 C8.82318271,4.1021611 8.30746562,3.32612967 7.28094303,3.07563851 L7.28094303,2 L5.80746562,2 L5.80746562,3.06090373 C4.8546169,3.26719057 4.08840864,3.88605108 4.08840864,4.83398821 C4.08840864,5.96856582 5.02652259,6.53339882 6.39685658,6.86247544 C7.62475442,7.15717092 7.87033399,7.58939096 7.87033399,8.04616896 C7.87033399,8.38506876 7.62966601,8.92534381 6.54420432,8.92534381 C5.5324165,8.92534381 5.1345776,8.47347741 5.0805501,7.89390963 L4,7.89390963 C4.0589391,8.96954813 4.86444008,9.57367387 5.80746562,9.77504912 L5.80746562,10.8408644 L7.28094303,10.8408644 L7.28094303,9.7848723 C8.23870334,9.60314342 9,9.0481336 9,8.04125737 C9,6.64636542 7.8064833,6.16994106 6.69155206,5.88015717 Z",
  id: "path-1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.5,0 C2.90976562,0 0,2.90976562 0,6.5 C0,10.0902344 2.90976562,13 6.5,13 C10.0902344,13 13,10.0902344 13,6.5 C13,2.90976563 10.0902344,0 6.5,0 Z",
  id: "Path",
  fill: "#E02020",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "icon/editor/attach_money_24px",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
})));

var SvgDollarWithRedCircle = function SvgDollarWithRedCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDollarWithRedCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar-with-red-circle.6fde0c5d.svg";
export { ForwardRef as ReactComponent };